@let surveyModel = $surveyModel();
@let transitions = $transitions();

<kendo-card width="auto" class="general-card">
  <kendo-card-body>
    @if (surveyModel) {
      <unity-stepper-survey-shared [isLoading]="false" [surveyModel]="surveyModel" (pageChangeEvent)="onPageChangeEvent($event)">
        @if (!!surveyModel) {
          <ng-container form-response-survey>
            <survey [model]="surveyModel" />
          </ng-container>
        }
      </unity-stepper-survey-shared>
    }
  </kendo-card-body>
  <kendo-card-footer class="response-footer">
    <kendo-stacklayout orientation="horizontal" [gap]="5" [align]="{ horizontal: 'end' }">
      @let isCreating = $isCreating();
      <button kendoButton type="button" themeColor="error" [svgIcon]="cancelIcon" [disabled]="isCreating" (click)="handleCancel()">
        Cancel
      </button>
      @if ($showSubmit()) {
        @for (action of transitions; track action.id) {
          <button
            type="button"
            kendoButton
            themeColor="secondary"
            [svgIcon]="saveIcon"
            [disabled]="isCreating"
            (click)="handleCreate(action)">
            {{ action.name }}
          </button>
        }
      }
      @if (isCreating === true) {
        <kendo-loader id="submit-loading" type="infinite-spinner" size="small" themeColor="info" />
      }
    </kendo-stacklayout>
  </kendo-card-footer>
</kendo-card>
